import { h } from 'preact';
import * as BaseComp from 'components/shared/footer/footer.js';
import s from 'components/shared/footer/footer.sss';

export default class Footer extends BaseComp.default {

	getStudioLink() {
		let top = super.getStudioLink();

		// let url = 'https://greenwichentertainment.us17.list-manage.com/subscribe/post?u=66fa7b2b379ec4c844d7dcb0f&amp;id=dd79c46fc9';
		// let url = 'https://magpictures.us1.list-manage.com/subscribe/post?u=ab5877ee186347ba63ae226bc&amp;id=c14176c05c';
		// let u = '66fa7b2b379ec4c844d7dcb0f';
		// let id = 'dd79c46fc9';
		let signup = (
			<div class={s.mc_embed_signup}>
			<form action="https://magpictures.us1.list-manage.com/subscribe/post?u=ab5877ee186347ba63ae226bc&amp;id=c14176c05c" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class={s.validate} target="_blank" novalidate>
			    <label for="mce-EMAIL">Join for Early Screenings and Exclusive Offers</label>
			    <div id="mc_embed_signup_scroll" class={s.inputs}>
				
					<input type="email" value="" name="EMAIL" class={s.email} id="mce-EMAIL" placeholder="email address" required />
				    <div style="position: absolute; left: -5000px;" aria-hidden="true">
				    	<input type="text" name="b_ab5877ee186347ba63ae226bc_c14176c05c" tabindex="-1" value="" />
				    </div>
				    <div class={s.clear}>
				    	<input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class={s.button} />
				    </div>
			    </div>
			</form>
			</div>
		);

		return [].concat(signup, top);
	}

}
 